export default [
    {
      title: 'menu.Products',
      icon: 'PackageIcon',
      tagVariant: 'light-warning',
      route: 'products'
    },
  ]